<template>
  <div>
    <div class="notifications-list">
      <!-- <notificationmessage
        v-for="notification in notifications"
        :key="notification.id"
        :notification="notification"
      /> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import notificationmessage from "./NotificationMessage";
export default {
  name: "notificationlist",
  components: {
    notificationmessage
  },
  computed: {
    ...mapState({
      notifications: state => state.app.notifications
    })
  }
};
</script>

<style scoped>
.notifications-list {
  z-index: 99;
  position: fixed;
  bottom: 0;
  right: 0;
  margin-right: 15px;
  width: 350px;
}
</style>
